import { localizeWithPath } from 'vscode/vscode/vs/nls';
import { Codicon } from 'vscode/vscode/vs/base/common/codicons';
import { language } from 'vscode/vscode/vs/base/common/platform';
import { ContextKeyExpr } from 'vscode/vscode/vs/platform/contextkey/common/contextkey';
import { registerIcon } from 'vscode/vscode/vs/platform/theme/common/iconRegistry';

const _moduleId = "vs/workbench/contrib/localHistory/browser/localHistory";
let localHistoryDateFormatter = undefined;
function getLocalHistoryDateFormatter() {
    if (!localHistoryDateFormatter) {
        const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
        let formatter;
        try {
            formatter = new Intl.DateTimeFormat(language, options);
        }
        catch (error) {
            formatter = new Intl.DateTimeFormat(undefined, options);
        }
        localHistoryDateFormatter = {
            format: date => formatter.format(date)
        };
    }
    return localHistoryDateFormatter;
}
const LOCAL_HISTORY_MENU_CONTEXT_VALUE = 'localHistory:item';
const LOCAL_HISTORY_MENU_CONTEXT_KEY = ( (ContextKeyExpr.equals('timelineItem', LOCAL_HISTORY_MENU_CONTEXT_VALUE)));
const LOCAL_HISTORY_ICON_ENTRY = registerIcon('localHistory-icon', Codicon.circleOutline, ( localizeWithPath(_moduleId, 0, "Icon for a local history entry in the timeline view.")));
const LOCAL_HISTORY_ICON_RESTORE = registerIcon('localHistory-restore', Codicon.check, ( localizeWithPath(_moduleId, 1, "Icon for restoring contents of a local history entry.")));

export { LOCAL_HISTORY_ICON_ENTRY, LOCAL_HISTORY_ICON_RESTORE, LOCAL_HISTORY_MENU_CONTEXT_KEY, LOCAL_HISTORY_MENU_CONTEXT_VALUE, getLocalHistoryDateFormatter };
